import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=a70a7c2c&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=ts"
export * from "./TagList.vue?vue&type=script&lang=ts"
import style0 from "./TagList.vue?vue&type=style&index=0&id=a70a7c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a7c2c",
  null
  
)

export default component.exports